import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Container } from "semantic-ui-react";

import SegmentMessage from "../forms/messages/SegmentMessage.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ValidationMessage extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    dismissable: PropTypes.bool.isRequired,
    timed: PropTypes.bool.isRequired,
    startTime: PropTypes.number,
    endTime: PropTypes.number
  };

  static defaultProps = {
    dismissable: false,
    timed: false,
    startTime: undefined,
    endTime: undefined
  };

  // -- RENDER -- //

  isInTimeWindow = () => {
    const { startTime, endTime } = this.props;

    if (!startTime && !endTime) return true;
    if (!startTime && endTime) return Date.now() < endTime;
    if (startTime && !endTime) return startTime < Date.now();

    return startTime < Date.now() && Date.now() < endTime;
  };

  render() {
    const { title, message, dismissable, timed, className, style } = this.props;

    if (!this.isInTimeWindow()) return null;

    return (
      <Container style={{ marginBottom: "30px" }}>
        <SegmentMessage
          title={title}
          message={message}
          timed={timed}
          dismissable={dismissable}
          warning={true}
          className={className}
          style={style}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ValidationMessage);
